// extracted by mini-css-extract-plugin
export var inlineLink = "_78-0";
export var inlineLinkButton = "_78-1";